import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsConsent({ checked, onChange, testId = 'career-terms-consent' }) {
  return (
    <label className="flex items-start gap-2.5 text-sm text-neutral-600 cursor-pointer mt-4" data-testid={testId}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-indigo-600 shrink-0" data-testid={`${testId}-checkbox`} />
      <span>
        I agree to the{' '}
        <Link to="/terms" target="_blank" className="text-indigo-600 font-medium hover:underline" data-testid={`${testId}-terms`}>Terms of Use</Link>
        {' '}and{' '}
        <Link to="/privacy" target="_blank" className="text-indigo-600 font-medium hover:underline" data-testid={`${testId}-privacy`}>Privacy Policy</Link>
      </span>
    </label>
  );
}

export function GoogleConsentNote() {
  return (
    <p className="text-[11px] text-neutral-500 text-center mt-2" data-testid="career-google-consent-note">
      By continuing with Google, you agree to the <Link to="/terms" target="_blank" className="underline">Terms of Use</Link> and <Link to="/privacy" target="_blank" className="underline">Privacy Policy</Link>.
    </p>
  );
}
